import React,{ useEffect, useContext, useState, useRef } from "react";
// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Cards } from "../components/Cards/cards";
import { ModalVisualizarCronograma } from "./components/Avisos/ModalVisualizarCronograma";
import { ModalVisualizarPortafolio } from "./components/Avisos/ModalVisualizarPortafolio";
import { ModalVisualizarSocializaciones } from "./components/Avisos/ModalVisualizarSocializaciones";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { AiFillFacebook, AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { Footer } from "../../../components/Landing/Footer";
import { Banner } from "../components/Banner/Banner";
import { useNavigate } from "react-router-dom";
import getStorageUser from "../../../middlewares/GetStorageUser"
import { Form, Select, Input, Button, Collapse, Table, Empty, Row, Col, Popover, Space, Carousel } from "antd";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { QuienParticipaOptions, tipoConvocatoria } from "../../../utils/dataSelectOptions";
import { TemplateContext } from "../../../utils/template_context";
import apiMaestras from "../../../api/Maestras/api-maestras";

import '../PeopleList.scss';

import segundaMobile from "../../../assets/pp/Home-Banner.jpg";
import segundaDesktop from "../../../assets/pp/Home-Banner.jpg";
import botonEstimulos from "../../../assets/pp/Boton Estimulos.jpg";
import banner2 from "../../../assets/pp/Banner-Resenas-1-estimulos.jpg"
import banner3 from "../../../assets/pp/Banner-Resenas-2-estimulos.jpg"
import botonCronograma from "../../../assets/pp/Boton Cronograma.jpg";
import botonSocializaciones from "../../../assets/pp/Banne-3.jpg";

import creativa from "../../../assets/landing/economicaCreativa.png"


// Hook
import { useLanding } from "../../../hooks/useLanding";
// style
import "../landing.style.scss";
import { color } from "html2canvas/dist/types/css/types/color";
import { borderBottomStyle } from "html2canvas/dist/types/css/property-descriptors/border-style";

const routes = [
  { icon: <></>, nombre: "Alcaldía de Medellín" },
  { icon: <></>, nombre: "Secretaría Cultura Ciudadana" },
  { icon: <></>, nombre: "Convocatorias de Presupuesto Participativo" },
];
const coloresEstado = {
  Abierta: "#21BA45",
  "En espera": "#EFC236",
  Cerrada: "#9F0505",
};
const { Panel } = Collapse;

const blockquoteStyle = {
  background: '#FFF',
  border: 0,
  margin: '1px',
  padding: 0,
  boxShadow: 'none',
  display: 'block'
};

const divStyle = {
  padding: '16px'
};

const linkStyle = {
  color: '#000',
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '17px',
  textDecoration: 'none'
};

const divCarrusel = {
  backgroundColor: '#efefef',
  padding: '20px',
  borderRadius: '10px'
}

export const PpEstimulos = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    getSiguientesConvocatorias,
    visibleButton,
    setPrincipalState,
    buscarconvocatorias,
    limipiarfiltros,
    loadingConvocatorias
  } = useLanding();

  const navigate = useNavigate();

  React.useEffect(() => {
    getLineasConvocatorias();
  }, []);

  useEffect(() => {
    // Crear un script y añadirlo al DOM
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Limpiar el script cuando el componente se desmonte
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const context = useContext(TemplateContext);
  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [mostrarTabla, setMostrarTabla] = useState(false);

  const toggleVista = () => {
    setMostrarTabla(!mostrarTabla);
  };

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria, data) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    } else {
      if (data.nombre_convocatoria && data.nombre_convocatoria.includes("jurados")) {
        return "Banco de Jurados";
      } else {
        return "BEPS";
      }
    }
  };

  const fields = [
    { name: "perfil_participante", value: principalState.buscarconvocatorias.perfil_participante },
    { name: "area", value: principalState.buscarconvocatorias.area },
    { name: "entidad", value: principalState.buscarconvocatorias.entidad },
    { name: "linea_convocatoria", value: principalState.buscarconvocatorias.linea_convocatoria },
    { name: "categoria_linea_convocatoria", value: principalState.buscarconvocatorias.categoria_linea_convocatoria },
    { name: "buscar_palabra_clave", value: principalState.buscarconvocatorias.buscar_palabra_clave },
    { name: "tipo_convocatoria", value: principalState.buscarconvocatorias.tipo_convocatoria },
    { name: "anio", value: principalState.buscarconvocatorias.anio },
 ];

  const datosTabla = principalState.convocatoriasslice
  .filter((data: any) => data.entidad == "PP")
  .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
  .map((data: any) => ({
    // Mapear aquí los datos que quieres mostrar en la tabla
    idconvocatorias: data.idconvocatorias,
    nombre_convocatoria: data.nombre_convocatoria,
    fechas: data.fechas,
    estado: data.estado,
    entidad: data.entidad,
    linea_convocatoria: data.linea_convocatoria,
    tipo_participante: data.tipo_participante,
    area: data.area
  }));

  const columns = [
    {
      title: "Nombre convocatoria",
      width: 300,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      render: (datos) => {
        return (
          <span style={{whiteSpace: "pre-line"}}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "Línea convocatoria",
      width: 450,
      render: (datos) => {
        return (
          <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line" , fontWeight: "bold"}}>
            {getFilterLineaConvocatoria(datos?.linea_convocatoria, datos) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria, datos)}` : ""}
          </span>
        );
      },
    },
    {
      title: "Fecha apertura",
      width: 120,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Fecha cierre",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechacierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );
          if (fechacierre.length > 0) {
            fecha = fechacierre[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Tipo participante",
      width: 100,
      render: (datos) => {
        if (Array.isArray(datos.tipo_participante)) {
          var tipo_participante = ""
          datos.tipo_participante.forEach((tipo) => {
            tipo_participante += tipo.text + " - ";
          });
        }
        return <span className="font-family-Montserrat-Regular">{tipo_participante}</span>;
      }
    },
    {
      title: "Estado",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = new Date(fecha);
            cierreAct.setHours(cierreAct.getHours() - 1);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora){
              var estadoAct = 'Cerrada'
            } else {
              estadoAct = datos.estado
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                  {estadoAct}
                </span>)
      },
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Áreas",
      width: 200,
      render: (datos) => {
        if (Array.isArray(datos.area)) {
          let area = "";
          datos.area.forEach((tipo, index) => {
            area += tipo.text;
            if (index < datos.area.length - 1) {
              area += ", ";
            } else {
              area += ".";
            }
          });
          return <span className="font-family-Montserrat-Regular" style={{ whiteSpace: "pre-line" }}>{area}</span>;
        }
        return null;
      }
    }
  ];

  const handleRowClick = (record: any) => {
    window.open(`/estimuloscultura/verconvocatoria/${record.idconvocatorias}`, "_blank", "noopener,noreferrer")
  };

  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const [visualizarCronograma, setVisualizarCronograma] = useState<boolean>(false);
  const [visualizarPortafolio, setVisualizarPortafolio] = useState<boolean>(false);
  const [visualizarSocializaciones, setVisualizarSocializaciones] = useState<boolean>(false);

  const mostrarModalCronograma = () => {
    setVisualizarCronograma(true);
  }

  const mostrarModalPortafolio = () => {
    setVisualizarPortafolio(true);
  }

  const mostrarModalSocializaciones = () => {
    setVisualizarSocializaciones(true);
  }

  const contentStyle: React.CSSProperties = {
    width: '100%',
    objectFit: 'cover'
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const contentStyleC: React.CSSProperties = {
    width: "100%",
    height: "auto",
    objectFit: "cover"
  };

  const carouselRef = useRef<any>(null);
  const goToPrev = () => carouselRef.current?.prev();
  const goToNext = () => carouselRef.current?.next();

  return (
    <div>
      <Header />
      <HeaderPp />
      <div style={{ position: "relative", margin: "0 auto" }}>
        <Carousel
          ref={carouselRef}
          autoplay
          autoplaySpeed={3000}
          dots
          infinite
        >
          <div>
            <img src={segundaDesktop} alt="Banner 1" style={contentStyleC} />
          </div>
          <div>
            <img src={banner2} alt="Banner 2" style={contentStyleC} />
          </div>
          <div>
            <img src={banner3} alt="Banner 3" style={contentStyleC} />
          </div>
        </Carousel>
        {/* Flechas */}
        <button
          onClick={goToPrev}
          style={{
            position: "absolute",
            top: "50%",
            left: "16px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            cursor: "pointer"
          }}
        >
          <LeftOutlined style={{ fontSize: "18px" }} />
        </button>
        <button
          onClick={goToNext}
          style={{
            position: "absolute",
            top: "50%",
            right: "16px",
            transform: "translateY(-50%)",
            background: "rgba(0,0,0,0.5)",
            border: "none",
            color: "white",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            cursor: "pointer"
          }}
        >
          <RightOutlined style={{ fontSize: "18px" }} />
        </button>
      </div>
      <div className="container-fluid2 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={botonEstimulos}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Conoce el Portafolio de Estímulos 2025</h3>
                  <p className="card2-description">
                    Explora todas las oportunidades que tenemos para ti. Descubre las líneas, expresiones y estímulos disponibles y encuentra el espacio ideal para tu proyecto.
                  </p>
                  <p className="card2-description">
                    Lee el portafolio y haz parte de esta historia.
                  </p>
                  <Button
                    className="card2-button"
                    style={{ fontSize: '14px' }}
                    onClick={mostrarModalPortafolio}
                  >
                    <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Ver más</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {
            /*
            <div className="col-md-4">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={botonCronograma}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Consulta el cronograma de la Convocatoria de Estímulos 2025</h3>
                  <p className="card2-description">
                    Conoce cada una de las fechas clave del proceso: apertura, cierre de inscripciones, evaluaciones y resultados.
                  </p>
                  <p className="card2-description">
                    Organiza tu propuesta con tiempo y asegúrate de no dejar pasar ninguna etapa.
                  </p>
                  <Button
                    className="card2-button"
                    style={{ fontSize: '14px' }}
                    onClick={mostrarModalCronograma}
                  >
                    <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Ver más</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
            */
          }
          <div className="col-md-4">
            <div className="card2-container">
              <div className="card2">
                <img
                  src={botonSocializaciones}
                  alt="Random"
                  className="card2-image"
                />
                <div className="card2-content">
                  <h3 className="card2-title">Entérate de las fechas de socialización</h3>
                  <p className="card2-description">
                    Participa en los espacios informativos donde resolveremos tus dudas sobre el portafolio, requisitos y proceso de inscripción.
                  </p>
                  <p className="card2-description">
                    Consulta el calendario y acompáñanos.
                  </p>
                  <Button
                    className="card2-button"
                    style={{ fontSize: '14px' }}
                    onClick={mostrarModalSocializaciones}
                  >
                    <span className="container-detalle-card-body-bold" style={{ fontSize: '14px' }}>Ver más</span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="font-family-Montserrat text-center font-color-black" style={{fontSize:60}}>
          <strong>
            <h1 className="mb-5" style={{color: '#1e3a53'}}>
              Convocatoria de Estímulos 2025: ¡Es momento de crear!
            </h1>
          </strong>
          <h4 className="mb-3" style={{textAlign: 'center', marginTop: '10px'}}>
            Si tienes una idea que une, inspira y transforma, esta es tu oportunidad. La Convocatoria de Estímulos 2025 está diseñada para impulsar proyectos que fortalezcan el encuentro, la diversidad y el bienestar colectivo desde la creatividad.
          </h4>
          <h4 className="mb-3" style={{textAlign: 'center', marginTop: '10px'}}>
            En conmemoración de los <strong>350 años de Medellín</strong>, se suman <strong>10 nuevos estímulos</strong> enfocados en propuestas que exploren nuestra <strong>identidad, memoria y proyección como ciudad.</strong>
          </h4>
          <h4 className="mb-3" style={{textAlign: 'center', marginTop: '10px'}}>
            Este año la convocatoria está ofertada para las comunas 3 (Manrique), 4 (Aranjuez), 8 (Villa Hermosa), 9 (Buenos Aires), 10 (La Candelaria), 12 (La América) y 15 (Guayabal) y corregimientos 60 (San Cristóbal), 70 (Altavista) y 90 (Santa Elena). Contamos con 12 expresiones artísticas y culturales y 38 líneas de participación. Más espacios, más oportunidades, más razones para hacer parte de una Medellín más humana, creativa y unida.
          </h4>
          <h4 className="mb-3" style={{textAlign: 'center', marginTop: '10px'}}>
            <strong>Postúlate, crea y haz parte del cambio. ¡Medellín te está buscando!</strong>
          </h4>
        </div>
      </div>
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="container-titles-landing-prinicipal">
          <Form
              name="basic"
              className="bg-light"
              size="large"
              layout="vertical"
              fields={fields}
              style={{
                border: '1px solid #ccc',
                borderRadius: '30px',
                padding: '30px'
              }}
              onFieldsChange={async (_: any, fields: any) => {
                let infoupdate: any = { ...principalState.buscarconvocatorias };
                infoupdate[_[0].name[0]] = _[0].value;
                return setPrincipalState({ ...principalState, buscarconvocatorias: infoupdate });
              }}
          >
              <div className="row g-3 gb-0 mt-3 justify-content-center">
                {/*<div className="col-12 col-md-3 col-lg-3 mb-0 mt-0">
                    <Form.Item label="Nombre convocatoria" name="buscar_palabra_clave">
                      <Input style={{ width: "100%" }} placeholder="Nombre convocatoria" />
                    </Form.Item>
                </div>*/}
                <div className="col-12 col-md-5 col-lg-5 mb-0 mt-0">
                    <Form.Item label="Línea convocatoria" name="linea_convocatoria">
                      <Select
                          showSearch
                          optionFilterProp="children"
                          suffixIcon={<FlechaSelect />}
                          size="large"
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                      >
                          {principalState.linea_estrategicas.slice().reverse().filter(({ nombre }: any) => nombre.includes('- PP')).map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={id}>{nombre}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Perfil" name="perfil_participante">
                      <Select allowClear placeholder="Seleccionar...">
                          {QuienParticipaOptions.map(({ value, text }, i) => (
                            <Select.Option key={i} value={value}>{text}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                <div className="col-6 col-md-2 col-lg-2 mb-0 mt-0">
                    <Button className="button-azul-ghost" style={{ marginTop: '20px' }} onClick={limipiarfiltros}>
                      Limpiar filtros
                    </Button>
                    <Button className="button-azul-radius" onClick={buscarconvocatorias}>
                      Buscar
                    </Button>
                </div>
                {/*<div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Categoría" name="categoria_linea_convocatoria">
                      <Select dropdownMatchSelectWidth={false} disabled={principalState.categoria_linea_convocatorias.length < 1} allowClear placeholder="Seleccionar...">
                          {principalState.categoria_linea_convocatorias.map(({ id, nombre }) => (
                            <Select.Option key={id} value={id}>{nombre}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>*/}
                {/*<div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Tipo convocatoria" name="tipo_convocatoria">
                      <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                          {tipoConvocatoria.map(({ value, text }: any, i) => (
                            <Select.Option key={i} value={value}>{text}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                */}
                {/* <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Año" name="anio">
                      <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                          {principalState.anios.map((year: any, i) => (
                            <Select.Option key={i} value={year}>{year}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div> */}
              </div>
          </Form>
          <br />
        </div>
      </div>

      <div className="container-fluid2">
        <div className="row g-3">
          <div className="col-12">
            {/* Botón para cambiar entre tabla y tarjetas */}
            <Button onClick={toggleVista}>
              {mostrarTabla ? 'Mostrar en tarjetas' : 'Mostrar en tabla'}
            </Button>
          </div>
        </div>
      </div>
      <br />
      <div id="convocatorias"></div>
      {mostrarTabla ? (
        <div className="container-fluid2" style={{height: "600px", overflowY: 'auto', border: '1px solid #ccc'}}>
          <div className="row g-3">
            <div className="col-12">
              <Table
                style={{ borderTop: "1px solid #C4C4C4", fontSize: '16px' }}
                locale={{ emptyText: <Empty description="No hay información para mostrar" style={{ padding: "50px" }} /> }}
                pagination={false}
                columns={columns}
                dataSource={datosTabla}
                size="middle"
                bordered={false}
                loading={loadingConvocatorias}
                onRow={(record) => {
                  return {
                    onClick: () => handleRowClick(record),
                    style: {
                      cursor: 'pointer',
                    },
                  }
                }}
              />
            </div>
          </div>
        </div>
        ) :
        <div className="container-fluid2" style={{height: "800px", overflowY: 'auto', border: '1px solid #ccc'}}>
          <div className="row g-3">
          {principalState.convocatoriasslice
            .filter((data: any) => data.entidad == "PP") // Filtra solo las convocatorias con entidad "SM"
            .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias) // Ordena por idconvocatorias
            .map((data: any, index: number) => (
              <div key={`contenedor_${index}`} className="col-12 col-md-3">
                <Cards key={index} convocatorias={data} />
              </div>
            ))}
          </div>
        </div>
      }
      <br />
      <section className="video-section">
        <div className="video-wrapper">
          <div className="video-frame">
            <iframe
              src="https://drive.google.com/file/d/1JSVSP611c4swqrW3rr5kgXi4u8VUawel/preview"
              allow="autoplay"
              allowFullScreen
              loading="lazy"
              title="Video"
            ></iframe>
          </div>
          <div className="video-text">
            <h2>¿Por qué ser parte de la Convocatoria de Estímulos 2025?</h2>
            <p>
            Este video te muestra cómo tu creatividad puede transformar la ciudad. Escucha las voces que ya han hecho parte de esta experiencia y descubre por qué tu proyecto también puede marcar la diferencia.
            </p>
            <div className="social-icons">
              <a href="#"><AiFillFacebook /></a>
              <a href="#"><AiFillInstagram /></a>
              <a href="#"><AiFillYoutube  /></a>
            </div>
          </div>
        </div>
      </section>
      <ModalVisualizarCronograma
        visualizar={visualizarCronograma}
        setVisualizar={setVisualizarCronograma}
      />
      <ModalVisualizarPortafolio
        visualizar={visualizarPortafolio}
        setVisualizar={setVisualizarPortafolio}
      />
      <ModalVisualizarSocializaciones
        visualizar={visualizarSocializaciones}
        setVisualizar={setVisualizarSocializaciones}
      />
      <Footer />
    </div>
  );
};
